/**
 * Match current route to a nav link (supports aliases and prefix match).
 */
export function isNavActive(pathname, to, options = {}) {
  const { exact = false, aliases = [] } = options;
  const paths = [to, ...aliases].filter(Boolean);

  return paths.some((p) => {
    if (p === "/") {
      return pathname === "/" || pathname === "";
    }
    if (exact) {
      return pathname === p;
    }
    return pathname === p || pathname.startsWith(`${p}/`);
  });
}

/** Desktop / top bar nav link */
export function navActiveClass(pathname, to, options = {}) {
  return isNavActive(pathname, to, options) ? "dw-nav-active" : "";
}

/** Mobile slide menu link */
export function mmNavActiveClass(pathname, to, options = {}) {
  return isNavActive(pathname, to, options) ? "mm-nav-active" : "";
}

export function isDashboardNavActive(pathname, profileID) {
  if (pathname === "/user-profile-edit") return true;
  if (profileID && pathname === `/user-profile/${profileID}`) return true;
  return false;
}
